import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { PasswordSubmitResponse, PasswordErrorType } from './types';

/**
 * Submits valid password for user password change
 *
 * @method submitPasswordChange
 * @memberof Password
 * @param  {string} password - New password
 * @returns {Promise<PasswordSubmitResponse>} - Status of password change and any errors returned
 */

export const submitPasswordChange = async (password: string): Promise<PasswordSubmitResponse> => {
  const url = `${Constants.BACKEND_URL}/users/password`;

  return httpPost(url, { password })
    .then((response) => {
      if (response?.status === 200) {
        return {
          success: true,
          error: null,
        };
      } else {
        return {
          success: false,
          error: PasswordErrorType.OTHER,
        };
      }
    })
    .catch((error) => {
      let type;
      switch (error.response.data.response) {
        case 'Can not repeat prior password':
          type = PasswordErrorType.REPEAT_PASSWORD;
          break;
        case 'Password does not support minimum security requirements':
          type = PasswordErrorType.STRENGTH;
          break;
        default:
          type = PasswordErrorType.OTHER;
      }
      return {
        success: false,
        error: type,
      };
    });
};
